module.exports = __webpack_public_path__ + "img/preview.d48424ca.jpg";